import React from 'react';

const GameResult = ({ result, user, onPlayAgain }) => {
  const isWinner = result.winner_id === user?.id;
  const myId = user?.id;
  const myScore = result.scores[myId];
  const opponentId = Object.keys(result.scores).find(id => parseInt(id) !== myId);
  const opponentScore = result.scores[opponentId];
  const opponentUsername = result.usernames?.[opponentId] || `玩家${opponentId}`;
  
  return (
    <div style={{ textAlign: 'center', padding: '40px' }}>
      <h2>{isWinner ? '🎉 胜利！ 🎉' : '😭 失败 😭'}</h2>
      <div style={{ fontSize: '24px', margin: '20px 0' }}>
        <p>你的分数: <strong>{myScore}</strong></p>
        <p>{opponentUsername} 分数: <strong>{opponentScore}</strong></p>
      </div>
      <button onClick={onPlayAgain} className="btn btn-primary" style={{ padding: '12px 30px', fontSize: '18px' }}>
        返回大厅
      </button>
    </div>
  );
};

export default GameResult;